<template>
  <v-container fluid>
    <ClientsSearch />
    <v-flex xs12>
      <ClientSingle :clientId="clientId" />
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClientSingle from './../components/Client/ClientSingle.vue';
import ClientsSearch from '../components/Clients/Search.vue';

export default {
  name: 'clients',
  components: {
    ClientSingle,
    ClientsSearch,
  },
  computed: {
    ...mapGetters('clients', [
    ]),
    clientId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions('clients', [
      'getSingleClient',
    ]),
  },
  mounted() {
    this.getSingleClient(this.clientId);
  },
};
</script>
